import { JiraIntegration } from "@p0security/shared/integrations/trackers/jira/types";
import { Tenant } from "components/Login";
import { useFirestoreDoc } from "providers/FirestoreProvider";
import { useContext } from "react";

export const useTracker = () => {
  const tenantId = useContext(Tenant);
  const jira = useFirestoreDoc<JiraIntegration>(
    `o/${tenantId}/integrations/jira`
  );

  return jira.doc?.data.state === "installed" ? jira.doc.data : undefined;
};
